import axios from '../../config/axios';
import apiPaths from '../apiPaths';

const onGetWorklistClaims = (params) =>
  axios.get(apiPaths.claimsBase, {
    params: {
      ...params,
      only_in_worklist: true,
      sort: '-updated_at_claim_and_settlements_and_messages',
      paging: false
    }
  });

const onGetWorklistClaimMessages = (claimId) =>
  axios.get(`${apiPaths.worklistBase}/messages/`, { params: { claim_id: claimId } });

const onGetWorklistClaimUnreadSince = (claimId) =>
  axios.get(`${apiPaths.worklistBase}/unread-since`, { params: { claim_id: claimId } });

const onDeleteWorklistClaimUnreadSince = (claimId) =>
  axios.delete(`${apiPaths.worklistBase}/unread-since`, { params: { claim_id: claimId } });

const onGetClaimMessageRecipientOrganizations = (claimId) =>
  axios.get(`${apiPaths.worklistBase}/message-recipient-organizations`, { params: { claim_id: claimId } });

const onUpdateWorklistClaimMessage = (message) => axios.put(`${apiPaths.worklistBase}/messages/${message.id}`, message);

const onCreateWorklistClaimMessage = (claimId, message, params = {}) =>
  axios.post(`${apiPaths.worklistBase}/messages`, message, {
    params: {
      ...params,
      claim_id: claimId
    }
  });

const onCreateClaimMessageRecommendation = (claimId, payload) =>
  axios.post(`${apiPaths.claimsBase}/${claimId}/message-recommendation`, payload, { suppressErrorNotification: true });

const onGetClaimAiRecommendation = (claimId) => axios.get(`${apiPaths.claimsBase}/${claimId}/ai-recommendation`);

const onGetWorklistClaimRecommendations = (claimId) =>
  axios.get(`${apiPaths.worklistBase}/recommendations`, { params: { claim_id: claimId } });

const onGetWorklistClaimReminders = (claimId) =>
  axios.get(`${apiPaths.worklistBase}/reminders`, { params: { claim_id: claimId } });

const onCreateWorklistClaimReminder = (claimId, reminder) =>
  axios.post(`${apiPaths.worklistBase}/reminder`, reminder, { params: { claim_id: claimId } });

const onUpdateWorklistClaimReminder = (reminderId, reminder) =>
  axios.put(`${apiPaths.worklistBase}/reminders/${reminderId}`, reminder);

const onDeleteWorklistClaimReminder = (reminderId) => axios.delete(`${apiPaths.worklistBase}/reminders/${reminderId}`);

const onPostWorklistClaimBipro = (claimId) => axios.post(`${apiPaths.claimsBase}/${claimId}/bipro-send`);

const onPostWorklistClaimSettlementBipro = (params) =>
  axios.post(`${apiPaths.settlementsBase}/${params.settlementId}/bipro-send`, null, {
    params: { automated_payment_request: params.automatedPaymentRequest }
  });

const onPostWorklistClaimSettlementPropertyExpert = (params) =>
  axios.post(`${apiPaths.settlementsBase}/${params.settlementId}/property-expert-send`);

export {
  onGetWorklistClaims,
  onGetWorklistClaimMessages,
  onGetWorklistClaimUnreadSince,
  onDeleteWorklistClaimUnreadSince,
  onGetClaimMessageRecipientOrganizations,
  onUpdateWorklistClaimMessage,
  onCreateWorklistClaimMessage,
  onGetWorklistClaimRecommendations,
  onGetWorklistClaimReminders,
  onCreateWorklistClaimReminder,
  onUpdateWorklistClaimReminder,
  onDeleteWorklistClaimReminder,
  onPostWorklistClaimBipro,
  onCreateClaimMessageRecommendation,
  onGetClaimAiRecommendation,
  onPostWorklistClaimSettlementBipro,
  onPostWorklistClaimSettlementPropertyExpert
};
